import React, { createContext, useContext, useState, useCallback } from "react";

const DICT = {
  nl: {
    app_name: "Core Emotion",
    tagline: "Ontdek de kernemotie van jouw organisatie",
    login: "Inloggen",
    register: "Registreren",
    logout: "Uitloggen",
    email: "E-mailadres",
    password: "Wachtwoord",
    name: "Naam",
    org_name: "Organisatienaam",
    free_register: "Gratis registreren",
    no_account: "Nog geen account?",
    has_account: "Al een account?",
    start_free: "Start gratis",
    dashboard: "Mijn traject",
    admin: "Beheer",
    account: "Account",
    // landing
    hero_title: "Bepaal de kernemotie van jouw organisatie",
    hero_sub: "In zes elegante fases ontdek je samen met AI de merkessentie — het ene gevoel dat klanten raakt én medewerkers in vuur en vlam zet.",
    hero_tile: "Je kernemotie is de essentie van je merk!",
    get_started: "Begin gratis",
    learn_more: "Meer weten",
    // phases
    phase: "Fase",
    phases: "Fases",
    next: "Volgende",
    prev: "Vorige",
    save: "Opslaan",
    saved: "Opgeslagen",
    add: "Toevoegen",
    remove: "Verwijderen",
    ai_suggest: "AI-suggesties",
    ai_left: "keer over",
    ai_recluster: "Hercluster met AI",
    uses_left: "resterend",
    optional: "Optioneel",
    active: "Actief",
    completed: "Voltooid",
    locked: "Vergrendeld",
    // phase titles
    p1_title: "Organisatie-informatie",
    p1_intro: "We verzamelen alle belangrijke informatie over je organisatie om later de merkessentie te kunnen bepalen. Vul in wat relevant is — we geven in deze fase nog géén merkessentie.",
    p2_title: "Klantcontactmomenten",
    p2_intro: "Klantcontactmomenten zijn álle momenten, locaties en dingen waar een klant of potentiële klant in contact komt met de organisatie. Voeg ze toe als versleepbare blokjes; ze worden automatisch geclusterd. Laat de AentI maximaal 3× meedenken over momenten die je nog niet bedacht hebt.",
    p3_title: "Goede gevoelens",
    p3_intro: "Welke goede gevoelens krijgen klanten bij de contactmomenten? Onderscheid gevoelens die er al zijn (in de praktijk) van gevoelens die gewenst zijn maar nog niet voorkomen. We willen er héél veel. De AI mag 3× extra suggesties geven.",
    p4_title: "Tegeltjeswijsheden",
    p4_intro: "Dit zijn de belangrijkste en grootste clusters van goede gevoelens. Bedenk tegeltjeswijsheden — principes die verklaren waaróm juist deze goede gevoelens de moeite waard zijn. Bewaar er zoveel je wilt, maar kies uiteindelijk twee.",
    p5_title: "Kernemotie",
    p5_intro: "De kernemotie is de merkessentie: het gevoel dat de klant krijgt én dat medewerkers oprecht in vuur en vlam zet. Het is letterlijk één positief woord.",
    p6_title: "Legend Platform & Glory Story",
    p6_intro: "Samen met de AI stellen we het legendarische verhaal achter je organisatie vast via de Hero's Journey — met de klant als held en de organisatie als nederige marktkoopman die de klant in staat stelt held te worden.",
    // phase 3
    in_practice: "In de praktijk",
    p1_subject: "de organisatie-informatie",
    p2_subject: "de klantcontactmomenten",
    p3_subject: "de goede gevoelens",
    p4_subject: "de tegeltjeswijsheden",
    desired: "Gewenst",
    p3_no_touchpoints: "Voeg eerst klantcontactmomenten toe in Fase 2.",
    feeling_prompt: "Welk goed gevoel krijgt (of zou moeten krijgen) de klant hier?",
    earlier_feelings: "Eerder genoemde gevoelens — klik om te koppelen",
    ask_type: "Wordt dit al ervaren of is het gewenst?",
    linked_here: "Gekoppeld aan dit moment",
    weight_overview: "Overzicht & gewicht",
    times_named: "× genoemd",
    ai_for_touchpoint: "AI-ideeën voor dit moment",
    moment_of: "Klantcontactmoment",
    of_word: "van",
    no_feelings_here: "Nog geen gevoelens bij dit moment.",
    // phase 4
    tile_line1: "Regel 1",
    tile_line2: "Regel 2",
    save_tile: "Tegeltje opslaan",
    download: "Download",
    select_tile: "Kies dit tegeltje",
    selected: "Gekozen",
    watermark: "Made with core-emotion.com",
    top_clusters: "Grootste clusters",
    // phase 5
    propose_word: "Stel een woord voor",
    core_emotion_set: "Vastgestelde kernemotie",
    not_set_yet: "Nog niet vastgesteld",
    consultant_block: "Alleen een Think Two Products Ahead Licensed TTPA consultant kan de kernemotie vaststellen en checken of een voorgesteld positief gevoel écht de kernemotie is. De consultant moet emotioneel geroerd zijn bij het horen ervan — daarom kan geen computer dit doen.",
    consultant_price: "Tarief: €250 op ons kantoor in Amstelveen (TIOUW.com BV, Binderij 7-L, 1185 ZH Amstelveen). Elders: €250 plus reis- en verblijfkosten (achteraf gefactureerd).",
    book_consultant: "Boek de check — €250",
    consultant_booked: "Check besteld — we nemen contact op",
    admin_set_core: "Kernemotie instellen (superadmin)",
    superadmin_only: "Alleen de superadmin kan de kernemotie instellen.",
    set: "Instellen",
    // phase 6
    locked_phase6: "Fase 6 is beschikbaar zodra de kernemotie is vastgesteld door een admin. Schaf de Think Two Products Ahead Licensed TTPA consultant check aan (Fase 5) om dit te ontgrendelen.",
    generate_story: "Genereer Glory Story",
    download_pdf: "Download PDF",
    manifesto: "Merkmanifest",
    // upgrade
    upgrade_title: "Werk samen met je team",
    upgrade_sub: "Gratis gebruik je alles voor jezelf. Nog beter wordt het als collega's meedoen. Nodig je team uit voor €1000.",
    upgrade_cta: "Team toevoegen — €1000",
    invite_title: "Nodig collega's uit",
    invite_sub: "Deel deze link. Collega's registreren en komen meteen in jouw organisatie.",
    invite_admin_note: "Je kan ook collega's toevoegen in het beheerscherm.",
    copy_link: "Kopieer",
    copied: "Gekopieerd!",
    joining_org: "Je registreert voor",
    paid_badge: "Team actief",
    free_badge: "Gratis plan",
    // admin
    organizations: "Organisaties",
    users: "Gebruikers",
    members: "Leden",
    role: "Rol",
    create_org: "Organisatie aanmaken",
    create_user: "Gebruiker aanmaken",
    paid: "Betaald",
    paid_team: "Team €1000",
    paid_consultant: "Consultant €250",
    core_emotion: "Kernemotie",
    actions: "Acties",
    deleted: "Verwijderd",
    landing_tiles: "Landingpagina",
    add_sentence: "Zin toevoegen",
    sentence: "Tegeltjeszin voor de landingpagina",
    make_admin: "Maak org admin",
    make_employee: "Maak medewerker",
    // payment
    pay_success: "Betaling geslaagd!",
    pay_success_sub: "Je aankoop is verwerkt.",
    pay_cancel: "Betaling geannuleerd",
    back_to_app: "Terug naar het traject",
    processing: "Bezig met verwerken…",
    employees: "Medewerkers",
    add_employee: "Medewerker toevoegen",
    cannot_remove: "Medewerkers kunnen toevoegen maar niet verwijderen.",
  },
  en: {
    app_name: "Core Emotion",
    tagline: "Discover your organization's core emotion",
    login: "Log in",
    register: "Register",
    logout: "Log out",
    email: "Email",
    password: "Password",
    name: "Name",
    org_name: "Organization name",
    free_register: "Register for free",
    no_account: "No account yet?",
    has_account: "Already have an account?",
    start_free: "Start free",
    dashboard: "My journey",
    admin: "Admin",
    account: "Account",
    hero_title: "Determine your organization's Core Emotion",
    hero_sub: "In six elegant phases you discover, together with AI, the brand essence — the single feeling that moves customers and sets employees on fire.",
    hero_tile: "Your core emotion is the essence of your brand!",
    get_started: "Start free",
    learn_more: "Learn more",
    phase: "Phase",
    phases: "Phases",
    next: "Next",
    prev: "Previous",
    save: "Save",
    saved: "Saved",
    add: "Add",
    remove: "Remove",
    ai_suggest: "AI suggestions",
    ai_left: "left",
    ai_recluster: "Re-cluster with AI",
    uses_left: "left",
    optional: "Optional",
    active: "Active",
    completed: "Completed",
    locked: "Locked",
    p1_title: "Organization information",
    p1_intro: "We gather all relevant information about your organization so we can determine the brand essence later. Fill in what is relevant — we do not reveal a brand essence in this phase.",
    p2_title: "Customer touchpoints",
    p2_intro: "Touchpoints are all the moments, locations and things where a (potential) customer comes into contact with the organization. Add them as draggable blocks; they are clustered automatically. Let the AI add moments you haven't thought of — up to 3 times.",
    p3_title: "Good feelings",
    p3_intro: "Which good feelings do customers get at the touchpoints? Distinguish feelings that already exist (in practice) from feelings that are desired but not yet present. We want a lot of them. The AI may give extra suggestions 3 times.",
    p4_title: "Wisdom tiles",
    p4_intro: "These are the biggest, most important clusters of good feelings. Create wisdom tiles — principles that explain why exactly these good feelings are worth having. Save as many as you like, but ultimately choose two.",
    p5_title: "Core Emotion",
    p5_intro: "The core emotion is the brand essence: the feeling the customer gets and that genuinely sets employees on fire. It is literally one positive word.",
    p6_title: "Legend Platform & Glory Story",
    p6_intro: "Together with AI we establish the legendary story behind your organization using the Hero's Journey — with the customer as the hero and the organization as the humble market vendor who enables the customer to become the hero.",
    in_practice: "In practice",
    p1_subject: "the organization information",
    p2_subject: "the customer touchpoints",
    p3_subject: "the good feelings",
    p4_subject: "the wisdom tiles",
    desired: "Desired",
    p3_no_touchpoints: "First add customer touchpoints in Phase 2.",
    feeling_prompt: "Which good feeling does (or should) the customer get here?",
    earlier_feelings: "Previously mentioned feelings — click to link",
    ask_type: "Is this already experienced or desired?",
    linked_here: "Linked to this touchpoint",
    weight_overview: "Overview & weight",
    times_named: "× named",
    ai_for_touchpoint: "AI ideas for this touchpoint",
    moment_of: "Touchpoint",
    of_word: "of",
    no_feelings_here: "No feelings for this touchpoint yet.",
    tile_line1: "Line 1",
    tile_line2: "Line 2",
    save_tile: "Save tile",
    download: "Download",
    select_tile: "Select this tile",
    selected: "Selected",
    watermark: "Made with core-emotion.com",
    top_clusters: "Biggest clusters",
    propose_word: "Propose a word",
    core_emotion_set: "Established core emotion",
    not_set_yet: "Not set yet",
    consultant_block: "Only a Think Two Products Ahead Licensed TTPA consultant can determine the core emotion and verify whether a proposed positive feeling is truly the core emotion. The consultant must be emotionally moved upon hearing it — that is why no computer can do this.",
    consultant_price: "Rate: €250 at our office in Amstelveen (TIOUW.com BV, Binderij 7-L, 1185 ZH Amstelveen). Elsewhere: €250 plus travel and accommodation (billed afterwards).",
    book_consultant: "Book the check — €250",
    consultant_booked: "Check ordered — we will contact you",
    admin_set_core: "Set core emotion (superadmin)",
    superadmin_only: "Only the superadmin can set the core emotion.",
    set: "Set",
    locked_phase6: "Phase 6 becomes available once the core emotion has been set by an admin. Purchase the Think Two Products Ahead Licensed TTPA consultant check (Phase 5) to unlock it.",
    generate_story: "Generate Glory Story",
    download_pdf: "Download PDF",
    manifesto: "Brand manifesto",
    upgrade_title: "Work together with your team",
    upgrade_sub: "For free you use everything by yourself. It gets even better when colleagues join. Invite your team for €1000.",
    upgrade_cta: "Add team — €1000",
    invite_title: "Invite colleagues",
    invite_sub: "Share this link. Colleagues register and join your organization directly.",
    invite_admin_note: "You can also add colleagues in the admin screen.",
    copy_link: "Copy",
    copied: "Copied!",
    joining_org: "You're joining",
    paid_badge: "Team active",
    free_badge: "Free plan",
    organizations: "Organizations",
    users: "Users",
    members: "Members",
    role: "Role",
    create_org: "Create organization",
    create_user: "Create user",
    paid: "Paid",
    paid_team: "Team €1000",
    paid_consultant: "Consultant €250",
    core_emotion: "Core emotion",
    actions: "Actions",
    deleted: "Deleted",
    landing_tiles: "Landing page",
    add_sentence: "Add sentence",
    sentence: "Tile sentence for the landing page",
    make_admin: "Make org admin",
    make_employee: "Make employee",
    pay_success: "Payment successful!",
    pay_success_sub: "Your purchase has been processed.",
    pay_cancel: "Payment cancelled",
    back_to_app: "Back to the journey",
    processing: "Processing…",
    employees: "Employees",
    add_employee: "Add employee",
    cannot_remove: "Employees can add but not remove.",
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const detect = () => {
    const saved = localStorage.getItem("ce_lang");
    if (saved) return saved;
    return (navigator.language || "en").toLowerCase().startsWith("nl") ? "nl" : "en";
  };
  const [lang, setLangState] = useState(detect);
  const setLang = useCallback((l) => {
    localStorage.setItem("ce_lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((key) => DICT[lang][key] ?? DICT.en[key] ?? key, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
